import React, { useEffect, useRef } from 'react'
import cn from "classnames";

function InnerHtml(props) {
  const { html, isPreview } = props
  const iframeRef = useRef(null)

  useEffect(() => {
    if (!html || !iframeRef.current) return

    const iframe = iframeRef.current
    const doc = iframe.contentDocument || iframe.contentWindow.document

    // Write the HTML content to iframe
    doc.open()
    doc.write(html)
    doc.body.style.overflow = 'hidden'
    doc.close()

    // Make iframe height match content
    const resizeIframe = () => {
      if (iframe && iframe.contentWindow) {
        iframe.style.height = iframe.contentWindow.document.documentElement.scrollHeight + 'px'
      }
    }

    // Resize initially and on content changes
    resizeIframe()
    iframe.onload = resizeIframe

  }, [html])

  return (
    <div className={cn({'is-preview': isPreview})}>
      <iframe
        ref={iframeRef}
        style={{
          border: 'none',
          width: '100%',
        }}
        title="content"
      />
    </div>

  )
}

export default InnerHtml